import { RARITY_CONFIG } from '@/constants/rewards';
import type { Rarity } from '@/types/rewards';

interface RarityPillProps {
  rarity: Rarity;
  className?: string;
}

export function RarityPill({ rarity, className = '' }: RarityPillProps) {
  const config = RARITY_CONFIG[rarity];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${className}`}
      style={{
        color: config.color,
        backgroundColor: config.bg,
        border: `1px solid ${config.border}`,
      }}
    >
      {config.label}
    </span>
  );
}
